import { v4 } from 'uuid';

import { ComponentOptions } from '../types';
import { ComponentVendorDataIn } from './types';
import { RecordData } from '../../helpers-classes';

export const componentVendorData = (options: ComponentOptions<ComponentVendorDataIn>): ComponentVendorDataIn => {
	const rd = new RecordData<ComponentVendorDataIn>(options.dataIn);

	const record: ComponentVendorDataIn = {
		id: rd.useNewOrPartial<string>('id', v4()),
		displayValue: rd.useNewOrDefault<string>('displayValue', null),
		description: rd.useNewOrDefault<string>('description', null),
		active: rd.useNewOrDefault<boolean>('active', true)
	};

	return record;
};
